export enum ModalName {
  addPatient,
  emailSupport,
  reportWizard,
  resetDemoPatients,
  resetUserSettings,
  preview,
  releaseInfo,
}

export type ModalParams = {
  [ModalName.addPatient]: undefined
  [ModalName.emailSupport]: undefined
  [ModalName.reportWizard]: undefined
  [ModalName.resetDemoPatients]: undefined
  [ModalName.resetUserSettings]: undefined
  [ModalName.preview]: undefined
  [ModalName.releaseInfo]: {
    releaseId: string
  }
}

export type ModalState = {
  openModal: <T extends ModalName>(name: T, params?: ModalParams[T]) => boolean
  closeModal: (name?: ModalName) => void
  modal?: ModalName
  modalParams?: ModalParams[ModalName]
}
